export default {
  type: 'ignoredProjectTitles',
  name: 'Ingored Project Title',
  permissions: {
    view: { app: 'metrics_dash', role: 'metrics_fy_users' },
    insert: { app: 'metrics_dash', role: 'metrics_fy_users' },
    update: { app: 'metrics_dash', role: 'metrics_fy_users' },
    delete: { app: 'metrics_dash', role: 'metrics_fy_users' }
  },
  search: {
    search: 'allIgnoreProjectTitles',
    orderBy: {
      type: 'IgnoreProjectTitlesOrderBy',
      default: 'PROJECT_TITLE_ASC'
    },
    fields: [
      {
        name: 'projectTitle',
        order: 'PROJECT_TITLE'
      }
    ]
  },
  save: {
    fields: [
      {
        field: 'projectTitle',
        required: true
      }
    ],
    key: ['projectTitle'],
    input: 'ignoreProjectTitle',
    create: 'createIgnoreProjectTitle',
    delete: 'deleteIgnoreProjectTitle',
    update: 'updateIgnoreProjectTitle'
  },
  load: {
    nodeId: 'ignoreProjectTitle',
    key: 'ignoreProjectTitleByProjectTitle'
  },
  form: {
    print: false,
    schema: [
      {
        name: 'projectTitle',
        required: true
      }
    ]
  }
}
